import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { ChatbotApi } from 'entities/Chatbot'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'
import {
  AgentUsage,
  type IAgentUsageProps,
} from 'pages/chatbot/pages/calling/actions/checkUsageAgent/ui/AgentUsage'

export const checkUsageAgent = async (id: number, action: IAgentUsageProps['action']) => {
  const { data } = await ChatbotApi.getAgentUsage(id)

  if (data.inboxes.length) {
    const modalId = nanoid()

    modalStore.addModal({
      paddingContent: '0',
      id: modalId,
      type: ModalTypeList.DEFAULT,
      showHeader: false,
      showCloseButton: false,
      ModalContent: () => (
        <AgentUsage
          data={data}
          action={action}
          getInboxPath={(inbox) =>
            inbox.source === 'workflow'
              ? InboxesPath.inboxSmartCallFlow(inbox.team_id)
              : InboxesPath.inboxAiAutomation(inbox.team_id)
          }
        />
      ),
      primaryAction: {
        onAction: () => {
          modalStore.removeModal(modalId)
        },
        text: 'Close',
      },
    })

    return true
  } else {
    return false
  }
}
